import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllGuardians as apiFn } from "../../api/apiGuardians";
import { useSnackbar } from "notistack"; import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useRestoreAllGuardians() { const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreAllGuardians, isPending: isRestore } = useMutation({ mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["guardians"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { restoreAllGuardians, isRestore }; }
